import React from 'react';
import PropTypes from "prop-types";
import ReactDOM from 'react-dom';
import Footer from './footer.jsx';
import Header from './header.jsx';

import { FaShare, FaAngleUp, FaAngleDown } from 'react-icons/fa';

class EndView extends React.Component {

    genMain(numb, flip, base) {

        var icon = null;
        var c = "";
        if (numb != 0)
        {
            if (numb * flip > 0)
            {
                icon = (<FaAngleUp/>);
                c =  "greentext";
            }
            else
            {
                icon = (<FaAngleDown/>);
                c =  "redtext";
            }
        }

        return (
            <h1 class={c}>
                {base} {icon}
            </h1>
        );
    }

    genDeltaArrow(numb, flip, base) {

        var icon = null;
        var c = "";
        if (numb != 0)
        {
            if (numb * flip > 0)
            {
                icon = (<FaAngleUp/>);
                c =  "greentext";
            }
            else
            {
                icon = (<FaAngleDown/>);
                c =  "redtext";
            }
        }

        return (
            <div class={""}>
                was: {base - numb}
            </div>
        );
    }

    genRankDelta() {
        return (
            <table>
                <tr>
                    <td>
                        <div class="name2">
                            Rank:<br/>
                            
                            { this.genMain(this.props.rankDelta, -1, this.props.rank) }
                            { this.genDeltaArrow(this.props.rankDelta, -1, this.props.rank) }
                        </div>
                    </td>
                    <td>
                        <div class="name2">
                            MMR:<br/>

                            { this.genMain(this.props.scoreDelta, 1, this.props.score) }
                            { this.genDeltaArrow(this.props.scoreDelta, 1, this.props.score) }
                        </div>
                    </td>
                </tr>

            </table>
        );
    }

    genReplayButton() {

        return <div/>

        if (this.props.replayReady)
        {
            return (
                <button class="button3" onClick={this.props.clickShare}>View / Share Replay</button>
            );
        }
        else
        {
            return (
                <button class="button3dead">Game in progress...</button>
            );
        }
    }

	render() {

        if (this.props.rankedGame) {
            return (
                <div class="main3" id="main">
                    <div class="gameEnd">
                        { this.genRankDelta() }

                        <br/>
                        <button class="button3Large" onClick={this.props.clickFindGame}>{"Find ranked game"}</button>
                        <div class="vPadding"></div>
                        <button class="button2" onClick={this.props.clickMainMenu}>Main Menu</button>
                        <div class="vPadding"></div>
                        { this.genReplayButton() } 
                    </div>
                </div>
            );            
        }

        return (
            <div class="main3" id="main">
                <div class="gameEnd">
                    <br/>
                    <br/>
                    <button class="button1" onClick={this.props.clickFindGame}>{this.props.findGameText}</button>
                    <div class="vPadding"></div>
                    <button class={this.props.rankedGameInBackground ? "button3" : "button2"} onClick={this.props.clickMainMenu}>{this.props.rankedGameInBackground ? "Back to matchmaker" : "Main Menu"}</button>
                    <div class="vPadding"></div>
                    { this.genReplayButton() } 
                </div>
            </div>
        );
	}
}

EndView.defaultProps = {
  findGameText: "Find Game"
};

EndView.propTypes = {
    rankedGameInBackground: PropTypes.bool,
    findGameText: PropTypes.string,
    replayReady: PropTypes.bool,
    clickFindGame: PropTypes.func,
    clickMainMenu: PropTypes.func,
    clickShare: PropTypes.func,
    rank: PropTypes.number,
    rankDelta: PropTypes.number,
    score: PropTypes.number,
    scoreDelta: PropTypes.number,
    ending: PropTypes.string,
    rankedGame: PropTypes.bool,
};

export default EndView;